import { gql } from "@apollo/client/core";
import fragments from '../fragments'

export default gql`
    ${fragments.Guarantee.GuaranteeCategory}
    mutation CreateGuaranteeCategory($title: String!, $description: String) {
        createGuaranteeCategory(input: { title: $title, description: $description }) {
            errors
            status
            statusCode
            guaranteeCategory {
                ...GuaranteeCategory
            }
        }
    }
`
